module.exports = __webpack_public_path__ + "static/img/logo.7cf6e29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 1